import React, { useState, useEffect } from 'react'
import Lottie from 'lottie-react'
import { loadingSpinner } from './assets'

const Spinner = (props) => {
  const { delay = 0, style } = props
  const [ready, setReady] = useState(delay === 0)
  useEffect(() => {
    let timeout = null
    if (!ready) {
      timeout = setTimeout(() => setReady(true), delay)
    }
    return () => {
      if (timeout) clearTimeout(timeout)
    }
  }, [])
  if (!ready) return null

  const containerStyle = {
    display: 'flex',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  }

  return (
    <div style={{ ...containerStyle, ...style }}>
      <Lottie style={{ maxHeight: '500px', maxWidth: '500px' }} animationData={loadingSpinner} loop />
    </div>
  )
}

export default Spinner
